/**
 * Props comuns das etapas do assistente.
 *
 * Toda etapa recebe o formulario INTEIRO e um `onChange` parcial: a etapa de
 * integracoes precisa das ofertas (para sugerir provedores) e a de acesso
 * precisa de tudo (revisao). Fatiar o estado por etapa obrigaria a pagina a
 * remontar o quebra-cabeca no fim.
 */

import type { Erros, FormNovaEmpresa } from '../../assistente';

export interface EtapaProps {
  readonly form: FormNovaEmpresa;
  readonly onChange: (patch: Partial<FormNovaEmpresa>) => void;
  readonly erros: Erros;
  /** `true` depois da primeira tentativa de avancar nesta etapa. */
  readonly mostrarErros: boolean;
}

export function erroDe(props: Pick<EtapaProps, 'erros' | 'mostrarErros'>, campo: string): string | null {
  return props.mostrarErros ? props.erros[campo] ?? null : null;
}
